import { HttpError } from '../http/HttpClient';

export class AuthClient {
  constructor({ http, tokenStore, basePath = '/auth' }) {
    this.http = http;
    this.tokenStore = tokenStore; // guarda access token
    this.basePath = basePath;
  }

  async login(credentials) {
    const data = await this.http.post(`${this.basePath}/api/v1/auth/local/login`, credentials);

    if (this.tokenStore && data?.token) {
      this.tokenStore.set({ accessToken: data?.token });
    }
    return data.user;
  }

  async me() {
    try {
      return await this.http.get(`${this.basePath}/api/v1/auth/userinfo`);
    } catch (e) {
      if (e instanceof HttpError && e.status === 401) return null;
      throw e;
    }
  }

  async refresh() {
    const data = await this.http.post(`${this.basePath}/api/v1/token/renew`);
    if (this.tokenStore && data?.token) {
      this.tokenStore.set({ accessToken: data?.token });
    }
  }

  async logout() {
    try { await this.http.get(`${this.basePath}/api/v1/auth/local/logout`); } catch { }
    if (this.tokenStore) this.tokenStore.clear();
  }

  async forgotPassword(data) {
    try {
      return await this.http.post(`${this.basePath}/api/v1/auth/local/forgot-password`, data);
    } catch (e) {
      throw e;
    }
  }

  async activateAccount(hash) {
    try {
      return await this.http.post(`${this.basePath}/api/v1/auth/local/activate-account`, { hash });
    } catch (e) {
      throw e;
    }
  }

  async acceptInvitation(data) {
    try {
      return await this.http.post(`${this.basePath}/api/v1/auth/local/accept-invitation`, data);
    } catch (e) {
      throw e;
    }
  }

  async resetPassword(data) {
    try {
      return await this.http.post(`${this.basePath}/api/v1/auth/local/reset-password`, data);
    } catch (e) {
      throw e;
    }
  }
}